import { ReactNode } from 'react';

import { useCollapsable } from '../../hooks/ui/useCollapsable';
import ToggleBar from '../ToggleBar/ToggleBar';

type CardHeaderProps = { children: ReactNode };

const CardHeader = ({ children }: CardHeaderProps) => {
    const { collapsed, setCollapsed, disabled } = useCollapsable();

    return (
        <ToggleBar
            disabled={disabled}
            onToggle={() => setCollapsed(!collapsed)}
            toggled={!collapsed}
        >
            {children}
        </ToggleBar>
    );
};

export default CardHeader;
